import { getCookie } from "./getCookie";


const changeLinkBot = () => {
    const MAX_WAIT_TIME = 10000; // Максимум 10 секунд ожидания
    const CHECK_INTERVAL = 500; // Проверять каждые 500мс
    const startTime = Date.now();
    
    const checkInterval = setInterval(() => {
        const ym_uid = getCookie("_ym_uid");
        const linksBot = document.querySelectorAll('[data-link-bot');
        
        // Если нашли UID или вышло время
        if (ym_uid || Date.now() - startTime > MAX_WAIT_TIME) {
            clearInterval(checkInterval);
            
            if (ym_uid && linksBot.length > 0) {
                linksBot.forEach(link => {
                    link.href = `https://t.me/ProfifutureBot?start=yaid_${ym_uid}`;
                })

                console.log('Замена ссылок на бот');
            }
        }
    }, CHECK_INTERVAL);
}

export default changeLinkBot;